import React from 'react'
import styled from 'styled-components'

const HeroInner = styled.div`
	height: 100%;

	@media (max-width: 1200px) {
		position: absolute;
		top: 50%;
		left: 0;
		right: 0;
		width: 100%;
		height: auto;
		transform: translateY(-50%);
	}
	@media (max-width: 768px) {
	}
`

const HeroTitle = styled.h1`
	font-size: 48px;
	font-weight: bold;
	line-height: 1.5;
	color: #fff;
	margin: 0;

	@media (max-width: 1200px) {
		font-size: 36px;
	}
	@media (max-width: 768px) {
		font-size: 28px;
	}
`
const HeroWrapper = styled.div`
	width: 100%;
	color: white;
	font-weight: bold;
	text-align: center;
	padding: 80px 0;
	background-color: #281284;

	.hero_container {
		height: 100%;
		max-width: 996px;
		padding: 0;
		margin: 0 auto;

		img {
			display: block;
			flex: 1;
			width: 100%;
			max-width: 688px;
			margin: 0 auto;
			object-fit: cover;
		}
	}

	@media (max-width: 1200px) {
		height: 280px;
		padding: 0;

		.hero_container {
			position: relative;
			display: block;

			img {
				width: 80%;
				margin: 0 auto;
			}
		}
	}
	@media (max-width: 768px) {
		height: 150px;
	}
`

export const ProtectHero: React.FC<{}> = ({}) => {
	return (
		<HeroWrapper>
			<div className={'hero_container'}>
				<HeroInner>
					<HeroTitle>
						R인증은 교육 콘텐츠의 <br />
						저작권을 보호합니다.
					</HeroTitle>
				</HeroInner>
			</div>
		</HeroWrapper>
	)
}
